import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddprojectComponent } from './components/addproject/addproject.component';
import { AddEditSalesPlanComponent } from './components/salesplan/addeditsalesplan/addeditsalesplan.component';
import { UnauthorizedComponent } from '../Common/Components/unauthorized/unauthorized.component';
import { UnsavedChangesGuard } from '../Common/guards/unsaved-changes.guard';
import { AddEditAdhocComponent } from './components/adhoc/add-edit-adhoc/add-edit-adhoc.component';
import { AdhocListComponent } from './components/adhoc/adhoc-list/adhoc-list.component';
import { AddEditStoreCoverageComponent } from './components/storecoverage/add-edit-store-coverage/add-edit-store-coverage.component';
import { StoreCoverageListComponent } from './components/storecoverage/store-coverage-list/store-coverage-list.component';

const routes: Routes = [
  {
    path: 'addproject',
    component: AddprojectComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'editproject/:id',
    component: AddprojectComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'editproject/:id/:catId',
    component: AddprojectComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'addsalesplan',
    component: AddEditSalesPlanComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'editsalesplan/:id',
    component: AddEditSalesPlanComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'editsalesplan/:id/:catId',
    component: AddEditSalesPlanComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'adhoc/add',
    component: AddEditAdhocComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  { path: 'adhoc/edit/:id', 
    component: AddEditAdhocComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'add-adhoc-list',
    component: AdhocListComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
   {
    path: 'storecoverage/add',
    component: AddEditStoreCoverageComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'storecoverage-list',
    component: StoreCoverageListComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectIntakeRoutingModule { }
